// Simple fetch wrapper; customize if you already have one
import { getSessionLocal } from './sessionLocal';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

function authHeaders() {
  // Phase 2b of the JWT-cookie migration: no `Authorization: Bearer …`
  // header — the auth token now travels exclusively in the httpOnly
  // `authToken` cookie (set on login by the server, sent automatically
  // by the browser via credentials: 'include' below).
  //
  // The X-Tenant-Id / X-User-Id / X-Role-Id / X-Role / X-Username
  // headers are vestigial — the server stopped trusting them in an
  // earlier round (every route now reads tenant + user from the
  // JWT-verified session, never from headers). Kept here for one more
  // release in case any unmigrated server code path still inspects them
  // for non-auth purposes.
  const s = getSessionLocal();
  const h = {};
  if (s.tenantId) h['X-Tenant-Id']   = String(s.tenantId);
  if (s.userId)   h['X-User-Id']     = String(s.userId);
  if (s.roleId)   h['X-Role-Id']     = String(s.roleId);
  if (s.role)     h['X-Role']        = s.role;
  if (s.username) h['X-Username']    = s.username;
  return h;
}

export const makeHeaders = (tenantId, extra = {}) => {
  const h = {
    'Content-Type': 'application/json',
    ...(tenantId ? { 'x-tenant-id': String(tenantId) } : {}),
    ...extra,
  };
  return h;
};

export const getJson = async (url, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    credentials: 'include',
    headers: { ...authHeaders(), ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};

export const postJson = async (url, body, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(opts.headers || {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.message || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return res.json();
};

export const delJson = async (url, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { ...authHeaders(), ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json().catch(() => ({}));
};

export const patchJson = async (url, body, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(opts.headers || {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.message || data.error || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return res.json();
};
